const MessageInfo = (props) => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx='9' cy='9' r='9' fill='#00B3CC' />
    <path d='M10 15H8V7H10V15Z' fill='white' />
    <path d='M10 5H8V3H10V5Z' fill='white' />
  </svg>
);
export default MessageInfo;
